import FilePdf from '../../src/legacy/FilePdf';
export default FilePdf;
